var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { reset } from '../styles.js';
import { styles } from './styles.js';
const variants = [
    'primary',
    'secondary',
    'negative',
    'negativeQuiet',
    'utility',
    'utilityQuiet',
    'quiet',
    'link',
    'overlay',
    'overlayInverted',
    'overlayQuiet',
    'overlayInvertedQuiet',
];
/**
 * Buttons are used to perform actions, with different visuals for different needs.
 *
 * [See Storybook for usage examples](https://warp-ds.github.io/elements/?path=/docs/buttons-link--docs)
 */
class WarpLink extends LitElement {
    constructor() {
        super(...arguments);
        this.autofocus = false;
        this.variant = 'secondary';
        this.small = false;
        this.disabled = false;
        this.fullWidth = false;
    }
    static { this.shadowRootOptions = {
        ...LitElement.shadowRootOptions,
        delegatesFocus: true,
    }; }
    static { this.styles = [reset, styles]; }
    connectedCallback() {
        super.connectedCallback();
        if (!variants.includes(this.variant)) {
            throw new Error(`Invalid "variant" attribute. Set its value to one of the following:\n${variants.join(', ')}.`);
        }
    }
    firstUpdated() {
        if (this.autofocus) {
            setTimeout(() => this.focus(), 0);
        }
    }
    render() {
        const classes = {
            // @ts-expect-error link should be removed so we hide it from types until we can do so
            'w-button': this.variant !== 'link',
            'w-button--primary': this.variant === 'primary',
            'w-button--secondary': this.variant === 'secondary',
            'w-button--negative': this.variant === 'negative',
            'w-button--utility': this.variant === 'utility',
            'w-button--quiet': this.variant === 'quiet',
            'w-button--negative-quiet': this.variant === 'negativeQuiet',
            'w-button--utility-quiet': this.variant === 'utilityQuiet',
            'w-button--overlay': this.variant === 'overlay',
            'w-button--overlay-inverted': this.variant === 'overlayInverted',
            'w-button--overlay-quiet': this.variant === 'overlayQuiet',
            'w-button--overlay-inverted-quiet': this.variant === 'overlayInvertedQuiet',
            'w-button--small': this.small,
            'w-button--full-width': this.fullWidth,
            'w-button--disabled': this.disabled,
        };
        return html `<a
      href=${this.href}
      target=${this.target}
      rel=${this.target === '_blank' ? this.rel || 'noopener' : undefined}
      class=${classMap(classes)}>
      <slot></slot>
    </a>`;
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], WarpLink.prototype, "autofocus", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpLink.prototype, "small", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "href", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpLink.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "target", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "rel", void 0);
__decorate([
    property({ attribute: 'full-width', type: Boolean, reflect: true })
], WarpLink.prototype, "fullWidth", void 0);
if (!customElements.get('w-link')) {
    customElements.define('w-link', WarpLink);
}
export { WarpLink };
//# sourceMappingURL=link.js.map